import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { useSpring, animated } from "react-spring";
import FormControl from "@material-ui/core/FormControl";
import MailOutlineOutlinedIcon from "@material-ui/icons/MailOutlineOutlined";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import ShortTextIcon from "@material-ui/icons/ShortText";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import Button from "@material-ui/core/Button";
import { CircularProgress } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { HOST_URL, baseUrlRate, basename } from "../../../config";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./rms.css";
import MainLayout from "../../common/Layout/MainLayout";
import routeConstant from "../../../route/compoent/routeConstant";
import { LOCAL_STORAGE_KEY } from "../../../config";
import { getUserData } from "../../common/utility/Utils";
import { path } from "../../../order_managment/constants/apiPath";
import { NotificationManager } from "react-notifications";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import CaptchaTest from "../../common/utility/Captcha";
import { Divider } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "1.5rem",
  },
}));

const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

Fade.propTypes = {
  children: PropTypes.element,
  in: PropTypes.bool.isRequired,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
};

function RMSSignup() {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");

  const [name, setName] = useState("");
  const [number, setNumber] = useState(undefined);
  const [company, setCompany] = useState("");
  const [loading, setLoading] = useState(false);
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  // const history = useHistory();

  const navigate = useNavigate();

  console.log("Phone Number: ", name);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  const handleModalOpen = () => {
    setOpen(true);
  };

  const handleModalClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    onLogin();
  }, []);

  const letsLogin = () => {
    handleModalClose();
    navigate(routeConstant.SCHEDULE_LOGIN);
  };

  // console.log(token);

  const onLogin = () => {
    const emailAddress = "RmsAq1268";
    const password = "Soft@1234";
    const params = new URLSearchParams();
    params.append("username", emailAddress);
    params.append("password", password);
    params.append("macAddress", "");
    params.append("deviceType", "W");
    params.append("ipAddress", "");
    params.append("grant_type", "password");
    const END_POINT = `${HOST_URL}Login`;
    axios
      .post(END_POINT, params)
      .then((res) => {
        setToken(res.data.access_token);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const rmsSignUp = () => {
    console.log("RMS Signup Clicked");

    const fullName = name.trim();
    const emailAddress = email.trim();
    const companyName = company.trim();

    const header = {
      Authorization: `Bearer ${token}`,
      // UserName: "nezih@mtsnyc.com",
      // UserSecret: "Soft@1234",
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
      // originPostalCode: "78744",
      // destinationPostalCode: "44130",
      // ratedClass: "60",
      // weight: "140",
    };
    if (!fullName) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill your Full Name!");
    } else if (!/^[a-z][a-z\s]*$/i.test(fullName)) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill correct Full Name!");
    } else if (!number && !/^\d+$/.test(number)) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please enter valid Phone Number!");
    } else if (!emailAddress) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill your email address!");
    } else if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        emailAddress
      )
    ) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill correct email address!");
    } else if (!companyName) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill your Company name!");
    } else {
      setLoading(true);

      const URL = `${baseUrlRate}${path.GUEST_ACCESS_REQUEST}`;
      const params = {
        // user_id: email,
        fullName: name,
        email: email,
        // password: "",
        companyName: company,
        // country_code: "",
        // ActionName: "Add",
        mobileNumber: number,
      };
      // console.log(fullName);
      axios
        .post(URL, params, {
          headers: header,
        })
        .then((res) => {
          setLoading(false);
          console.log("RMS SIGN UP:", res);

          if (!loading) {
            NotificationManager.success(
              "Guest Access Request Successfully forwarded via eMail.",
              "",
              3000
            );
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          setOpenalert(true);
          setSeverity("error");
          setAlertText("Something went wrong!");
        });
    }
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  return (
    <div className="scheduleSignUpComp">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
      <Modal
        className={classes.modal + " materialModalContainer"}
        open={open}
        // onClose={handleModalClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper + " materialModal"}>
            <div className="filterModeComponent singupSuccessModal">
              <div className="modalHeading">
                <h6>User Created Successfully!</h6>
              </div>
              <div className="filterModalBody">
                <p>
                  Username and Password successfuly <br />
                  sent to <span className="modalEmail">{email}</span>.
                </p>
              </div>
              <div className="modalFooter mt-3">
                <Button variant="contained" onClick={letsLogin}>
                  Go to Login!
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
      <div className="scheduleSignUpCompBody">
        <div className="scheduleSignUpCompBodyInner">
          <img
            src={`/${basename}/Assets/Images/mtslogo.svg`}
            alt="mtsFavIcon"
          />
          <h4>Sign Up Request for RMS</h4>
          <Divider />
          <div className="userId">
            <FormControl className={clsx(classes.margin, classes.textField)}>
              <TextField
                id="standard-basic"
                label={
                  <span className="loginLabelSpan">
                    <ShortTextIcon /> Full name *
                  </span>
                }
                value={name}
                type="text"
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </FormControl>
          </div>
          <div className="userId">
            <FormControl className={clsx(classes.margin, classes.textField)}>
              {/* <TextField
                id="standard-basic"
                label={
                  <span className="loginLabelSpan">
                    <PhoneAndroidIcon /> Enter your Phone Number
                  </span>
                }
                value={number}
                type="number"
                onChange={(e) => {
                  setNumber(e.target.value);
                }}
              /> */}
              {/* <PhoneInput
                placeholder="Enter phone number"
                value={number}
                defaultCountry="IN"
                onChange={setNumber}
              /> */}
              <PhoneInput
                // className="form-control"
                placeholder="Contact number *"
                // id="floatingInput"
                // name="mobile"
                // dropdownstyle={{ height: "200px", width: "480px" }}
                defaultCountry="US"
                value={number}
                onChange={setNumber}
                style={{ border: "none" }}
              />

              {
                <span style={{ color: "red" }}>
                  {number === undefined ||
                  (number && isValidPhoneNumber(number))
                    ? ""
                    : "Enter Valid Number"}
                </span>
              }
            </FormControl>
          </div>
          <div className="userId">
            <FormControl className={clsx(classes.margin, classes.textField)}>
              <TextField
                id="standard-basic"
                label={
                  <span className="loginLabelSpan">
                    <MailOutlineOutlinedIcon /> Email address *
                  </span>
                }
                value={email}
                type="text"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </FormControl>
          </div>
          <div className="userId">
            <FormControl className={clsx(classes.margin, classes.textField)}>
              <TextField
                required
                id="standard-basic"
                label={
                  <span className="loginLabelSpan">
                    <LocationCityIcon /> Company name
                  </span>
                }
                value={company}
                type="text"
                onChange={(e) => {
                  setCompany(e.target.value);
                }}
              />
            </FormControl>
          </div>
          <CaptchaTest
            setAlertText={setAlertText}
            loading={loading}
            setOpenalert={setOpenalert}
            setSeverity={setSeverity}
            setLoading={setLoading}
            number={number}
            email={email}
            company={company}
            name={name}
            token={token}
            setCompany={setCompany}
            setName={setName}
            setEmail={setEmail}
            setNumber={setNumber}
          />
          <div className="loginButton my-3">
            {/* <Button variant="contained" onClick={() => rmsSignUp()}>
              {loading ? <CircularProgress size="1.5rem" /> : "Sign Up"}
            </Button> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RMSSignup;
